const cet = { standard: 'CET', dst: 'CEST' };

export default {
  Europe: {
    Amsterdam: cet,
    Berlin: cet,
    Brussels: cet,
    Copenhagen: cet,
    Oslo: cet,
    Paris: cet,
    Stockholm: cet,
  },
};
